import { render } from "./SearchBarComponent.vue?vue&type=template&id=5b164de4&scoped=true"
import script from "./SearchBarComponent.vue?vue&type=script&lang=js"
export * from "./SearchBarComponent.vue?vue&type=script&lang=js"

import "./SearchBarComponent.vue?vue&type=style&index=0&id=5b164de4&scoped=true&lang=css"

import exportComponent from "/home/u1042/tmp/bet-clipcut-003-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b164de4"]])

export default __exports__